const AccountConnectionSkeleton = () => {
  return (
    <div className="flex flex-row gap-2 items-start p-4 bg-white border border-gray-200 rounded-lg animate-pulse min-w-[400px] md:min-w-[500px] lg:min-w-[600px] xl:min-w-[700px] min-h-[88px]">
      {/* Logo skeleton */}
      <div className="w-14 h-14 bg-gray-200 rounded-lg flex-shrink-0" />

      {/* Right side content skeleton */}
      <div className="flex flex-row flex-1 min-w-0 gap-2">
        {/* Left column skeleton */}
        <div className="flex flex-col flex-1 min-w-0 gap-2">
          {/* Provider name box */}
          <div className="flex flex-row gap-2 bg-gray-50 rounded-md items-center px-3 h-10">
            <div className="w-16 h-4 bg-gray-200 rounded" />
          </div>
          {/* Description text - adjusted to match real text height */}
          <div className="pl-2 flex flex-col gap-1">
            <div className="h-3 w-full bg-gray-200 rounded" />
            <div className="h-3 w-4/5 bg-gray-200 rounded" />
          </div>
        </div>

        {/* Button skeleton - responsive width */}
        <div className="h-10 w-24 md:w-28 lg:w-32 bg-gray-200 rounded-md flex-shrink-0" />
      </div>
    </div>
  );
};

export default AccountConnectionSkeleton;
